import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { About } from './pages/About';
import { Layout } from './components/Layout';
import Pocketbase from './pages/Pocketbase';
import RoomEntry from './pages/RoomEntry';
import Room from './pages/Room';
import Home from './pages/Home';
import CivsPage from './pages/CivsPage';
import { RoomProvider } from './components/RoomContext';
import BuildOrderConfigurator from './components/BuildOrderConfigurator';
import ChampionGuide from './components/ChampionGuide';
import Challenges from './components/Challenges';
import FiveStackPlanner from './components/FiveStackPlanner';
import WhoDidItApp from './components/WhoDidItApp';
import AramGod from './pages/AramGod';

function App() {
  return (
    <Router>
      <RoomProvider>
        <Layout>
          <Routes>
            {/*<Route path="/" element={<Planner />} />*/}
            <Route path="/" element={<FiveStackPlanner />} />
            <Route path="/build" element={<BuildOrderConfigurator />} />
            <Route path="/guide" element={<ChampionGuide />} />
            <Route path="/game" element={<WhoDidItApp />} />
            <Route path="/challenges" element={<Challenges />} />
            <Route path="/aram-god" element={<AramGod />} />
            <Route path="/five" element={<FiveStackPlanner />} />
            <Route path="/about" element={<About />} />
            <Route path="/pocketbase" element={<Pocketbase />} />
            <Route path="/civs" element={<CivsPage />} />
            <Route path="/room-entry" element={<RoomEntry />} />
            <Route path="/room/:roomId" element={<Room />} />
          </Routes>
        </Layout>
      </RoomProvider>
    </Router>
  );
}

export default App;
